import { Stack } from 'expo-router';
import React from 'react';

function AccountsLayout() {
  return <Stack screenOptions={{ headerShown: false }} />;
}

export default AccountsLayout;
